// A course may carry several instructors (`instructors[]`) or, on lighter
// endpoints and older data, a single `instructor`. Normalize to one array so
// the UI never needs to know which shape the API sent.
export const getCourseInstructors = (course) => {
  if (!course) return [];
  if (Array.isArray(course.instructors) && course.instructors.length > 0)
    return course.instructors.filter(Boolean);
  if (course.instructor) return [course.instructor];
  return [];
};

// Lead-first label: "Layla", "Layla & Omar", or "Layla +2".
export const leadPlusLabel = (instructors = []) => {
  const names = instructors.map((i) => i?.name).filter(Boolean);
  if (names.length === 0) return "";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} & ${names[1]}`;
  return `${names[0]} +${names.length - 1}`;
};

// Comma label with overflow: "Layla", "Layla, Omar", or "Layla, Omar +1".
export const commaPlusLabel = (instructors = [], visible = 2) => {
  const names = instructors.map((i) => i?.name).filter(Boolean);
  if (names.length === 0) return "";
  const shown = names.slice(0, visible).join(", ");
  const extra = names.length - visible;
  return extra > 0 ? `${shown} +${extra}` : shown;
};
